module.exports = {
	"id": "GB",
	"name": "United Kingdom",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016761,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.011174,
			"22": 0.033522,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.011174,
			"27": null,
			"28": null,
			"29": 0.005587,
			"30": 0.005587,
			"31": 0.022348,
			"32": 0.011174,
			"33": 0.039109,
			"34": 0.027935,
			"35": 0.022348,
			"36": 0.022348,
			"37": 0.039109,
			"38": 0.050283,
			"39": 0.039109,
			"40": 0.044696,
			"41": 0.078218,
			"42": 0.067044,
			"43": 0.162023,
			"44": 0.050283,
			"45": 0.078218,
			"46": 0.072631,
			"47": 0.061457,
			"48": 0.128501,
			"49": 1.346467,
			"50": 0.134088,
			"51": 0.508417,
			"52": 0.581048,
			"53": 20.543399,
			"54": 5.056235,
			"55": 0.05587,
			"56": 0.016761,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005587,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.005587,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005587,
			"29": null,
			"30": 0.005587,
			"31": 0.016761,
			"32": 0.005587,
			"33": 0.011174,
			"34": 0.044696,
			"35": 0.027935,
			"36": 0.033522,
			"37": 0.011174,
			"38": 0.061457,
			"39": 0.022348,
			"40": 0.016761,
			"41": 0.027935,
			"42": 0.027935,
			"43": 0.078218,
			"44": 0.033522,
			"45": 0.122914,
			"46": 0.05587,
			"47": 0.379916,
			"48": 0.435786,
			"49": 5.447325,
			"50": 0.083805,
			"51": 0.005587,
			"52": null,
			"3.5": null,
			"3.6": 0.005587
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.039109,
			"37": 0.016761,
			"38": 0.039109,
			"39": 0.022348,
			"40": 0.33522,
			"41": 0.050283,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.033522
		},
		"safari": {
			"0": null,
			"4": 0.011174,
			"5": 0.05587,
			"6": 0.011174,
			"7": 0.061457,
			"8": 0.27935,
			"9": 0.368742,
			"10": 2.419171,
			"3.1": null,
			"3.2": null,
			"5.1": 0.16761,
			"6.1": 0.100566,
			"7.1": 0.022348,
			"9.1": 1.687274
		},
		"ios_saf": {
			"8": 0,
			"10": 13.8798991449,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.37404722117,
			"8.1-8.4": 0.691036391653,
			"9.0-9.2": 0.329668737302,
			"9.3": 5.029561505
		},
		"android": {
			"3": 0,
			"4": 0.024904372093,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00311304651163,
			"4.1": 0.089833627907,
			"4.2-4.3": 0.224584069767,
			"4.4": 0.514986837209,
			"4.4.3-4.4.4": 0.519434046512
		},
		"ie": {
			"6": null,
			"7": 0.0168101164835,
			"8": 0.268961863736,
			"9": 0.33620232967,
			"10": 0.274565235897,
			"11": 6.73525333773,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0754743740474,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00209651039021
		},
		"edge": {
			"12": 0.162023,
			"13": 0.793354,
			"14": 3.089611
		},
		"ie_mob": {
			"10": 0.186216169014,
			"11": 0.758165830986
		},
		"bb": {
			"7": 0.2360955,
			"10": null
		},
		"samsung": {
			"0": 4.673367
		},
		"and_uc": {
			"0": 0.423648
		},
		"op_mini": {
			"0": 1.01685311556
		},
		"and_chr": {
			"0": 14.833088
		},
		"and_ff": {
			"0": 0.057369
		}
	},
	"total": 97.6623983835
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GB.json
 ** module id = 525
 ** module chunks = 0
 **/